<template>
  <div :class="$style['logo']">
    <svg
      v-if="!props.hideIcon"
      :class="$style['logo__icon']"
      width="291"
      height="341"
      viewBox="0 0 291 341"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M80.4 33.5c10 0 19.7 3 27.5 8.4l-3 .9c-28.3 8.6-54 26.5-72.6 50.5V79.4c0-26.1 20.6-45.9 48-45.9zm46.9 131h-21V146H69.8v18.7h-33c9-44.7 41.6-80 83.5-90.6h.2l.6-.1 6.2-1.3v92zm-57.5 32.8v19.5h36.5v-19.5h83v19.5H226v-19.5h31.5c-2.5 35.3-20 67.3-48 88l-2.9 1.9a116.5 116.5 0 0 1-56.3 19.5 112.7 112.7 0 0 1-13-.3 116 116 0 0 1-52.8-19.3l-1.9-1a119.5 119.5 0 0 1-48.9-88.8h36.2zm156-32.7v-18.7h-36.5v18.7h-25.6v-92l6 1.2 1.5.4.7.2c6 1.6 12.2 3.9 18.6 6.8a117.6 117.6 0 0 1 63.7 83.4h-28.3zm32.9-85.2v14a147 147 0 0 0-75.6-51.5 48.5 48.5 0 0 1 27.5-8.4c27.4 0 48.1 19.8 48.1 46zM210.7 0c-26.1 0-50.3 12.6-65.2 33.7A79.4 79.4 0 0 0 80.4 0C36.4 0 .4 35.8 0 79.8v109c.2 50.5 24.2 97.6 64.2 126l3.7 2.6a140.9 140.9 0 0 0 50.6 21l1.2.1a129.1 129.1 0 0 0 10.1 1.6l2.5.2 5 .4 1.6.1 6.6.2c2.2 0 4.4 0 6.7-.2l9-.7 4.4-.6c2-.3 4-.6 6.8-1.2 18-3.5 35.1-10.6 50.8-21l5.7-4A155 155 0 0 0 291 188.8v-109A80.7 80.7 0 0 0 210.6 0z"
        fill="#000000"
        fill-rule="nonzero" />
    </svg>
    <svg
      v-if="!props.hideName"
      id="Layer_1"
      :class="$style['logo__text']"
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      version="1.1"
      x="0px"
      y="0px"
      width="1608.4817"
      height="140.463"
      viewBox="0 0 1608.4817 140.463"
      enable-background="new 0 0 1984.25 1133.86"
      xml:space="preserve"
      inkscape:version="0.48.2 r9819"
      sodipodi:docname="logo-smallscreens.svg">
      <path
        id="path3013"
        d="m 79.567645,53.235 h 57.821995 v 82.432 h -26.72 V 122.313 C 95.027645,134.712 78.614645,137.959 68.498645,137.959 30.144645,137.577 -0.38435512,106.854 0.00364488,68.503 0.38264488,30.53 31.296645,0 69.265645,0 h 0.568 c 16.222,0.195 30.918995,5.919 42.553995,15.266 l -19.271995,18.89 c -6.867,-4.771 -14.883,-7.253 -23.47,-7.44 h -0.38 c -11.254,0 -21.944,4.389 -29.961,12.397 -8.008,7.824 -12.592,18.51 -12.592,29.771 -0.188,11.254 4.202,22.13 12.024,30.146 8.009,8.205 18.698,12.789 29.956,12.789 h 0.573 c 11.257,0 21.753,-4.389 29.762,-12.213 5.725995,-5.538 9.547995,-12.209 11.448995,-19.653 H 79.567645 V 53.235 z"
        inkscape:connector-curvature="0" />
      <path
        id="path3015"
        d="m 278.29964,86.245 c 0,28.625 -23.285,51.714 -51.717,51.714 -28.618,0 -51.703,-23.089 -51.9,-51.522 V 1.912 h 26.714 v 84.334 c 0,6.681 2.673,12.979 7.446,17.75 4.77,4.769 11.061,7.247 17.74,7.247 6.684,0 12.789,-2.479 17.559,-7.247 4.767,-4.771 7.249,-10.874 7.443,-17.559 h -0.194 V 1.912 h 26.714 v 84.334 h 0.195 z"
        inkscape:connector-curvature="0" />
      <path
        id="path3017"
        d="m 434.65264,1.911 v 26.706 h -37.019 v 107.05 h -26.711 V 28.617 h -37.21 V 1.911 h 100.94 z"
        inkscape:connector-curvature="0" />
      <path
        id="path3019"
        d="m 529.76764,78.996 c -4.39,-1.142 -12.59,-3.246 -20.227,-8.4 -10.685,-7.059 -16.604,-17.36 -17.168,-30.145 -0.576,-10.686 2.861,-20.037 9.728,-27.284 C 512.02864,2.86 526.33364,0 533.20364,0 c 19.468,0 30.34,7.061 40.068,13.352 l 4.388,2.868 -13.931,22.709 -4.771,-3.054 c -8.582,-5.532 -14.119,-9.159 -25.755,-9.159 -1.715,0 -8.396,1.338 -11.832,4.957 -1.141,1.149 -2.476,3.245 -2.291,7.634 0.194,6.867 4.961,10.682 17.174,13.734 1.532,0.389 2.674,0.77 3.815,1.149 12.787,4.388 22.708,10.305 29.584,17.745 6.866,7.637 10.484,16.598 10.484,26.14 0,9.354 -3.998,19.081 -10.679,26.521 -7.823,8.778 -18.701,13.743 -30.725,13.743 -5.909,0 -13.928,-0.381 -23.471,-3.247 -12.014,-3.815 -22.706,-10.496 -31.863,-20.223 l 19.47,-18.317 c 14.111,15.069 29.955,15.069 35.864,15.069 11.069,0 14.698,-10.111 14.698,-13.547 0,-7.248 -8.206,-13.93 -22.142,-18.698 l -0.57,-0.186 -0.951,-0.194 z"
        inkscape:connector-curvature="0" />
      <path
        id="path3021"
        d="m 746.05564,124.791 c -4.767,8.584 -17.359,13.549 -26.334,13.549 -24.609,0 -45.797,-13.549 -45.797,-40.643 0,-16.983 8.584,-27.675 17.362,-34.16 -7.817,-7.44 -11.251,-16.026 -11.251,-27.088 0,-21.76 17.556,-36.449 39.309,-36.449 21.751,0 39.491,14.503 39.491,36.449 h -21.934 c 0,-10.689 -9.542,-14.504 -17.557,-14.504 -8.582,0 -17.359,4.958 -17.359,14.504 0,16.405 20.983,21.554 38.925,21.554 v 19.852 c -9.36,0 -18.133,-1.53 -26.152,-3.247 -18.505,6.867 -18.884,16.598 -18.884,23.09 0,12.403 8.967,19.459 23.848,19.459 15.085,0 26.334,-12.213 26.334,-21.372 V 84.34 h 21.942 v 51.327 h -21.374 l -0.569,-10.876 z"
        inkscape:connector-curvature="0" />
      <path
        id="path3023"
        d="m 919.37864,54.608 h 58.333 v 83.161 h -26.956 v -13.473 c -15.78,12.512 -32.341,15.784 -42.543,15.784 -38.693,-0.382 -69.494,-31.379 -69.104,-70.072 0.385,-38.309 31.567,-69.107 69.876,-69.107 h 0.573 c 16.367,0.195 31.193,5.963 42.931,15.398 l -19.443,19.062 c -6.927,-4.813 -15.013,-7.319 -23.676,-7.511 h -0.385 c -11.354,0 -22.138,4.431 -30.228,12.513 -8.081,7.887 -12.703,18.673 -12.703,30.03 -0.19,11.354 4.24,22.326 12.13,30.413 8.081,8.28 18.865,12.902 30.222,12.902 h 0.579 c 11.357,0 21.947,-4.428 30.025,-12.321 5.776,-5.588 9.634,-12.317 11.551,-19.825 h -31.183 V 54.608 z"
        inkscape:connector-curvature="0" />
      <path
        id="path3025"
        d="m 1119.8706,87.909 c 0,28.882 -23.489,52.172 -52.174,52.172 -28.874,0 -52.164,-23.29 -52.357,-51.975 V 2.827 h 26.951 v 85.082 c 0,6.738 2.694,13.097 7.508,17.907 4.811,4.813 11.157,7.313 17.898,7.313 6.74,0 12.902,-2.5 17.712,-7.313 4.813,-4.811 7.314,-10.973 7.511,-17.71 h -0.196 V 2.827 h 26.951 v 85.082 h 0.196 z"
        inkscape:connector-curvature="0" />
      <path
        id="path3027"
        d="m 1217.7396,80.595 c -4.428,-1.152 -12.702,-3.273 -20.406,-8.472 -10.776,-7.122 -16.749,-17.516 -17.32,-30.415 -0.579,-10.779 2.886,-20.211 9.814,-27.524 10.014,-10.393 24.447,-13.283 31.379,-13.283 19.63,0 30.609,7.124 40.428,13.472 l 4.423,2.894 -14.052,22.905 -4.811,-3.08 c -8.663,-5.588 -14.251,-9.241 -25.988,-9.241 -1.733,0 -8.474,1.349 -11.938,5.002 -1.152,1.163 -2.501,3.273 -2.305,7.704 0.188,6.929 5.002,10.778 17.319,13.857 1.543,0.391 2.697,0.775 3.853,1.158 12.896,4.428 22.905,10.391 29.839,17.9 6.93,7.705 10.591,16.749 10.591,26.373 0,9.436 -4.046,19.247 -10.784,26.755 -7.896,8.855 -18.864,13.863 -30.997,13.863 -5.963,0 -14.052,-0.383 -23.678,-3.273 -12.121,-3.85 -22.905,-10.59 -32.145,-20.399 l 19.638,-18.482 c 14.24,15.204 30.222,15.204 36.185,15.204 11.172,0 14.827,-10.203 14.827,-13.667 0,-7.313 -8.275,-14.052 -22.327,-18.868 l -0.578,-0.193 -0.967,-0.19 z"
        inkscape:connector-curvature="0" />
      <path
        id="path3029"
        d="m 1423.4146,2.827 v 26.946 h -37.348 v 107.996 h -26.951 V 29.773 h -37.538 V 2.827 h 101.837 z"
        inkscape:connector-curvature="0" />
      <path
        id="path3031"
        d="m 1608.4816,70.205 c 0,38.497 -31.374,69.876 -69.876,69.876 -38.497,0 -69.877,-31.379 -69.877,-69.876 0,-38.505 31.38,-69.886 69.877,-69.886 38.502,0 69.876,31.381 69.876,69.886 z m -112.037,0 c 0,23.29 18.871,42.158 42.161,42.158 23.29,0 42.16,-18.868 42.16,-42.158 0,-23.293 -18.87,-42.163 -42.16,-42.163 -23.29,0 -42.161,18.87 -42.161,42.163 z"
        inkscape:connector-curvature="0" />
    </svg>
  </div>
</template>
<script setup>
const props = defineProps({
  hideIcon: {
    type: Boolean,
    default: false
  },
  hideName: {
    type: Boolean,
    default: false
  }
})
</script>
<style lang="scss" module>
.logo {
  align-items: center;
  display: inline-flex;
  height: 100%;
  position: relative;

  &__icon {
    width: 15%;
    background-color: transparent;
    height: 100%;
    margin-right: calc(var(--spacing ) * 2);
    overflow: visible;

    @media (max-width: #{$breakpoint-tiny - 1 }) {
      display: none;
    }

    path {
      fill: currentcolor;
    }
  }

  &__text {
    width: 85%;
    height: 100%;
    fill: currentcolor;
    overflow: visible;

    @media (max-width: #{$breakpoint-desktop - 1 }) {
      width: 150px;
    }

    @media (max-width: #{$breakpoint-tablet - 1 }) {
      width: 109px;
    }
  }

  &__progress {
    background-color: var(--grey);
    mix-blend-mode: lighten;
    height: 100%;
    transition: all 200ms var(--transition-easing);
  }
}

</style>
